import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

/** Recoverable query failure; copy reused verbatim from the interview runner. */
export function ErrorState({
  onRetry,
  retrying = false,
  message = "Не удалось связаться с сервером.",
}: {
  onRetry: () => void;
  retrying?: boolean;
  message?: string;
}) {
  return (
    <div className="mx-auto w-full max-w-md p-4">
      <Card role="alert">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" aria-hidden="true" />
            Что-то пошло не так
          </CardTitle>
          <CardDescription>{message}</CardDescription>
        </CardHeader>
        <CardContent>
          <Button onClick={onRetry} loading={retrying} className="w-full">
            <RefreshCw className="mr-2 h-4 w-4" aria-hidden="true" />
            Попробовать снова
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
